import React from "react";
import {
  mainRoutes as routes,
} from "config/routing";
import { Link, useLocation } from "react-router-dom";
import { checkActiveRoute } from "utils/CommonHelper";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { userInfoSelector } from "components/_selectors/authSelectors";
import { SUPER_ADMIN_ROLE_SLUG } from "config/config";

function NavbarLinks({userInfo}) {
  const location = useLocation();
  let pathname = location.pathname;
  const { t } = useTranslation();
  return (
    <>
      <ul className="navbar-nav">
        <li className="nav-item d-none">
          <Link
            to={routes.dashboard.path}
            className={`nav-link 
                        ${checkActiveRoute(
                          pathname,
                          [routes.dashboard.path],
                          false,
                          true
                        )}
                      `}
          >
            <i className="ni ni-tv-2 text-orange" /> {t("dashboard")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.teachers.path,
                        ])}
                      `}
            to={routes.teachers.path}
          >
            <i className="fas fa-user-friends text-orange" /> {t("teachers")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.students.path,
                        ])}
                      `}
            to={routes.students.path}
          >
            <i className="fas fa-user-graduate text-orange" /> {t("students")}
          </Link>
        </li>
        {(userInfo && userInfo.role == SUPER_ADMIN_ROLE_SLUG) &&
          <li className="nav-item">
            <Link
              className={`nav-link 
                          ${checkActiveRoute(pathname, [
                            routes.adminUsers.path,
                          ])}
                        `}
              to={routes.adminUsers.path}
            >
              <i className="fas fa-user-shield text-orange" /> {t("admin_users")}
            </Link>
          </li>
        }
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.paymentTransactions.path,
                        ])}
                      `}
            to={routes.paymentTransactions.path}
          >
            <i className="fas fa-money-bill text-orange" /> {t("payment_transactions")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.contentPage.path,
                        ])}
                      `}
            to={routes.contentPage.path}
          >
            <i className="fas fa-paragraph text-orange" /> {t("content_pages")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.emailNotification.path,
                        ])}
                      `}
            to={routes.emailNotification.path}
          >
            <i className="fas fa-mail-bulk text-orange" /> {t("email_notification")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.subscriptions.path,
                        ])}
                      `}
            to={routes.subscriptions.path}
          >
            <i className="fas fa-list-alt text-orange" /> {t("subscriptions")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link 
                        ${checkActiveRoute(pathname, [
                          routes.subscriptionTransactions.path,
                        ])}
                      `}
            to={routes.subscriptionTransactions.path}
          >
            <i className="fas fa-money-bill text-orange" /> {t("subscription_transactions")}
          </Link>
        </li>
        {(userInfo && userInfo.role == SUPER_ADMIN_ROLE_SLUG) &&
          <li className="nav-item">
            <Link
              className={`nav-link 
                          ${checkActiveRoute(pathname, [
                            routes.mobileAppsString.path,
                          ])}
                        `}
              to={routes.mobileAppsString.path}
            >
              <i className="fas fa-mobile text-orange" /> {t("mobile_apps_string")}
            </Link>
          </li>
        }
         <li className="nav-item">
            <Link
              className={`nav-link 
                          ${checkActiveRoute(pathname, [
                            routes.manageSubscription.path,
                          ])}
                        `}
              to={routes.manageSubscription.path}
            >
              <i className="fas fa-list-alt text-orange" /> {t("manage_subscription")}
            </Link>
          </li>
      </ul>
      {/* Divider */}
      {/* <hr className="my-3" /> */}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    userInfo: userInfoSelector(state),
  };
};
export default connect(mapStateToProps, {})(NavbarLinks);